import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
// Components.
// -----------------------------------------------------------------------------
import { forwardRef } from 'react';
import { TabsRoot } from './Tabs.styles';
import { isEmpty } from 'lodash';
import { TabsLabels } from './TabsLabels';
import { TabsContextProvider } from './Tabs.context';
import { TabsContents } from './TabsContents';
import { DEFAULT_MODE, DEFAULT_SELECTED_COLOR } from './Tabs.constants';
const Tabs = forwardRef(({ definitions, mode = DEFAULT_MODE, selectedColor = DEFAULT_SELECTED_COLOR, activeTabId, type, onTabChange, render = (renderTabs, renderContent) => (_jsxs(_Fragment, { children: [renderTabs(), renderContent()] })), ...rest }, ref) => {
    function renderTabs() {
        return (_jsx(TabsLabels, { definitions: definitions, mode: mode, selectedColor: selectedColor, type: type }));
    }
    function renderContent() {
        return _jsx(TabsContents, { definitions: definitions, mode: mode, type: type });
    }
    // Guard condition.
    if (isEmpty(definitions)) {
        return null;
    }
    // Render.
    // -------------------------------------------------------------------------
    return (_jsx(TabsContextProvider, { activeTabId: activeTabId, onTabChange: onTabChange, children: _jsx(TabsRoot, { ref: ref, ...rest, children: render(renderTabs, renderContent) }) }));
});
// Component configuration.
// -----------------------------------------------------------------------------
Tabs.displayName = 'Tabs';
export default Tabs;
//# sourceMappingURL=Tabs.js.map